import React, { useState } from "react";

import axios from "axios";
import { saveAuth, getSavedUser } from "./lib/globalfunction";
import { useNavigate, Link as RouterLink } from "react-router-dom";

export default function LoginPage({ onLogin }) {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleLogin = async () => {
    if (!email.trim() || !password.trim()) {
      // setMessageType("error");
      setMessage("Please fill in all fields");
      return;
    }

    setLoading(true);
    setMessage("");
    // setMessageType("");

    const config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/login`,
      headers: { "Content-Type": "application/json" },
      data: { loginname: email, otpcode: password },
    };

    try {
      const response = await axios.request(config);
      console.log("Login response:", response);
      if (response.data.status) {
        saveAuth(response.data.user);
        // notify parent (App) that login succeeded so it can render the next page
        if (typeof onLogin === "function") {
          onLogin(response.data.user);
          // navigate to home route
          try {
            navigate("/home");
          } catch (e) {
            // ignore
          }
        } else {
          // fallback: reload so App can pick up saved auth
          window.location.reload();
        }
      } else {
        setMessage(response.data.message);
      }

    } catch (err) {
      // setMessageType("error");
      const errMsg =
        err?.response?.data?.message ||
        err.message ||
        "Login failed. Please try again.";
      setMessage(errMsg);
    } finally {
      setLoading(false);
    }
  };

  /** Bypass login with a dummy user (no API call). Use when backend is unavailable or for local dev. */
  const handleDemoLogin = () => {
    const dummyUser = {
      id: "demo",
      loginname: "demo",
      name: "Demo User",
      role: "user",
    };
    saveAuth(dummyUser);
    if (typeof onLogin === "function") {
      onLogin(dummyUser);
      navigate("/home");
    } else {
      window.location.reload();
    }
  };

  return (
    <div data-theme="dark">
      <div className="fixed inset-0 w-full h-full pointer-events-none z-0 transition-colors duration-500">
        <div
          className="absolute top-[-10%] left-[-10%] w-96 h-96 rounded-full blur-[100px]"
          style={{ background: "var(--bg-grad-1)" }}
        ></div>
        <div
          className="absolute bottom-[-10%] right-[-10%] w-96 h-96 rounded-full blur-[100px]"
          style={{ background: "var(--bg-grad-2)" }}
        ></div>
      </div>

      <div
        className="relative z-10 w-full max-w-md mx-auto flex flex-col shadow-2xl transition-all duration-500 overflow-hidden"
        style={{
          height: "100dvh",
          background: "rgba(2, 6, 23, 0.8)",
          borderLeft: "1px solid var(--glass-border)",
          borderRight: "1px solid var(--glass-border)",
        }}
      >
        {/* Login Screen */}
        <div className="absolute inset-0 flex flex-col items-center justify-center z-50 bg-transparent p-8 animate-enter">
          <div
            className="w-28 h-28 rounded-full mb-8 flex items-center justify-center relative"
            style={{
              background: "var(--input-bg)",
              border: "1px solid var(--text-accent)",
              boxShadow: "0 0 20px rgba(6,182,212,0.2)",
            }}
          >
            <div className="w-16 h-16 text-accent">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                  d="M12 4v16m8-8H4"
                ></path>
              </svg>
            </div>
            <div className="absolute inset-0 rounded-full border-t-2 border-accent opacity-50 animate-[spin_4s_linear_infinite]"></div>
          </div>

          <div className="text-center mb-10">
            <h1
              className="text-4xl font-bold tracking-tight mb-2"
              style={{ color: "var(--text-main)" }}
            >
              Smart<span className="text-accent">Refer</span>
            </h1>
            <p className="text-xs uppercase tracking-[0.3em] text-muted">
              Intelligent Patient Referral
            </p>
          </div>

          <div className="w-full space-y-5 glass p-6 rounded-2xl">
            <div>
              <label className="input-label">User ID</label>
              <input
                type="text"
                className="input-field"
                placeholder="Enter ID"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}

                // value={email}
                // onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div>
              <label className="input-label">Passcode</label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  className="input-field pr-12"
                  placeholder="Enter Passcode"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onKeyPress={(e) => e.key === "Enter" && handleLogin()}
                  disabled={loading}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-muted hover:text-accent transition-colors p-1"
                  disabled={loading}
                >
                  {showPassword ? (
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                      />
                    </svg>
                  ) : (
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                      />
                    </svg>
                  )}
                </button>
              </div>
            </div>
            <button
              onClick={handleLogin}
              disabled={loading}
              className="w-full py-3 mt-4 rounded-xl bg-cyan-600 text-white font-bold shadow-lg hover:bg-cyan-500 transition-transform active:scale-95 flex justify-center items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? "AUTHENTICATING..." : "LOGIN"}
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M13 7l5 5m0 0l-5 5m5-5H6"
                ></path>
              </svg>
            </button>
            {message && (
              <p className="mt-2 text-sm text-center text-red-400">{message}</p>
            )}
            <button
              type="button"
              onClick={handleDemoLogin}
              className="w-full py-2.5 mt-3 rounded-xl border border-cyan-500/50 text-cyan-400 font-medium hover:bg-cyan-500/10 transition-colors text-sm"
            >
              Sign in with demo account (bypass)
            </button>
          </div>

          <p className="mt-8 text-[10px] text-muted opacity-50">v1.0.1</p>
        </div>
      </div>
    </div>
  );
}
